import React, { Component } from 'react';
import { FacebookProvider, Like, ShareButton } from 'react-facebook';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF } from '@fortawesome/free-brands-svg-icons';
import { Container, Row, Col } from 'react-bootstrap';

class CalculatorOutput extends Component {

    dogToHumanYears = (dogYears, dogMonths, dogSize) => {
        // Calculation
        let monthsToYears = dogMonths / 12;

        let humanYears;

        console.log(dogYears);

        if (+dogYears === 16) {
            humanYears = this.dogAgeTable[dogSize][dogYears];
        } else {
            humanYears = this.dogAgeTable[dogSize][dogYears]
                + (this.dogAgeTable[dogSize][+dogYears + 1] - this.dogAgeTable[dogSize][dogYears])
                * +monthsToYears.toFixed(2);
        }

        return {
            years: Math.trunc(humanYears),
            months: Math.trunc((humanYears - Math.floor(humanYears)) * 12)
        }
    }

    calculateDogSeniority = (humanYears) => {

        const dogSeniorityLevels = [
            'štenetom',
            'odraslim psom',
            'starijim psom'
        ];
        let dogSeniority = dogSeniorityLevels[1];

        if (humanYears.years < 18) {
            dogSeniority = dogSeniorityLevels[0]
        } else if (humanYears.years > 45) {
            dogSeniority = dogSeniorityLevels[2]
        }

        return dogSeniority;
    }

    getDogWords = () => {

        const dogYears = this.props.formData.dogYears;
        const dogYearsLastDigit = +dogYears.toString().split('').pop();

        let words = {
            svojih: 'svojom',
            godina: 'godinom',
            mjesec: 'mjesec',
            pas: 'pseći'
        };

        if (dogYears > 10) {
            words.svojih = 'svojih';
            words.godina = 'godina';
        } else if (dogYearsLastDigit > 1 && dogYearsLastDigit < 5) {
            words.svojih = 'svoje';
            words.godina = 'godine';
        } else if (dogYearsLastDigit < 1 || dogYearsLastDigit >= 5) {
            words.svojih = 'svojih';
            words.godina = 'godina';
        }

        if (this.props.formData.dogMonths > 1 && this.props.formData.dogMonths < 5) {
            words.mjesec = 'mjeseca';
            words.pas = 'pseća';
        } else if (this.props.formData.dogMonths < 1 || this.props.formData.dogMonths >= 5) {
            words.mjesec = 'mjeseci';
            words.pas = 'psećih';
        }

        return words;
    }

    getHumanWords = (humanYears) => {

        humanYears = { ...humanYears }
        humanYears['yearsLastDigit'] = +humanYears.years.toString().split('').pop();

        let words = {
            godina: 'godinu',
            mjesec: 'mjesec',
        };

        if (humanYears.years >= 11 && humanYears.years <= 15) {
            words.godina = 'godina';
        } else if (humanYears.yearsLastDigit > 1 && humanYears.yearsLastDigit < 5) {
            words.godina = 'godine';
        } else if (humanYears.yearsLastDigit < 1 || humanYears.yearsLastDigit >= 5) {
            words.godina = 'godina';
        }

        if (humanYears.months > 1 && humanYears.months < 5) {
            words.mjesec = 'mjeseca';
        } else if (humanYears.months < 1 || humanYears.months >= 5) {
            words.mjesec = 'mjeseci';
        }

        return words;
    }

    render() {
        const humanYears = this.dogToHumanYears(this.props.formData.dogYears, this.props.formData.dogMonths, this.props.formData.dogSize);
        const dogSeniority = this.calculateDogSeniority(humanYears, this.props.formData.dogSize);
        const dogWords = this.getDogWords();
        const humanWords = this.getHumanWords(humanYears);

        return (
            <div className="rezultat-wrapper">
                <hr />
                <p className="rezultat-title">REZULTAT:</p>
                <p>Da je tvoj pas <b className="text-uppercase">{this.props.formData.dogName}</b> čovijek, imao bi <b>{humanYears.years} {humanWords.godina} i {humanYears.months} {humanWords.mjesec}.</b></p>
                <p>Sa {dogWords.svojih} {this.props.formData.dogYears} {dogWords.godina} i {this.props.formData.dogMonths} {dogWords.pas} {dogWords.mjesec}, smatra se <b>{dogSeniority}</b>.</p>
                <hr />
                <div className="podijeli-wrapper">
                    <p className="podijeli-title">Podijeli na društvenim mrežama!</p>
                    <div>
                        <Container fluid>
                            <Row className="justify-content-center">
                                <Col xs={12} sm={6} md={4}>
                                    <FacebookProvider appId="689124385249203" wait>
                                        <ShareButton
                                            href="https://odjecazapse.com/kalkulator-psecih-godina"
                                            className="btn btn-facebook btn-md"
                                        >
                                            <FontAwesomeIcon icon={faFacebookF} /> <span>Podijeli na Facebooku</span>
                                        </ShareButton>
                                    </FacebookProvider>
                                </Col>
                                <Col xs={12} sm={6} md={4}>
                                    <FacebookProvider appId="689124385249203" wait>
                                        <Like
                                            href="https://www.facebook.com/OdjecaZaPseCom"
                                            colorScheme="light"
                                            className="btn btn-facebook btn-md text-center"
                                            size="large"
                                        />
                                    </FacebookProvider>
                                </Col>
                            </Row>
                        </Container>
                    </div>
                </div>
            </div >
        )
    }

    dogAgeTable = {
        small: {
            0: 0,
            1: 15,
            2: 24,
            3: 28,
            4: 32,
            5: 36,
            6: 40,
            7: 44,
            8: 48,
            9: 52,
            10: 56,
            11: 60,
            12: 64,
            13: 68,
            14: 72,
            15: 76,
            16: 80
        },
        medium: {
            0: 0,
            1: 15,
            2: 24,
            3: 28,
            4: 32,
            5: 36,
            6: 42,
            7: 47,
            8: 51,
            9: 56,
            10: 60,
            11: 65,
            12: 69,
            13: 74,
            14: 78,
            15: 83,
            16: 87
        },
        big: {
            0: 0,
            1: 15,
            2: 24,
            3: 28,
            4: 32,
            5: 36,
            6: 45,
            7: 50,
            8: 55,
            9: 61,
            10: 66,
            11: 72,
            12: 77,
            13: 82,
            14: 88,
            15: 93,
            16: 99
        },
        great: {
            0: 0,
            1: 12,
            2: 22,
            3: 31,
            4: 38,
            5: 45,
            6: 49,
            7: 56,
            8: 64,
            9: 71,
            10: 79,
            11: 86,
            12: 93,
            13: 100,
            14: 107,
            15: 114,
            16: 121
        }
    };
}

export default CalculatorOutput;